import { render, staticRenderFns } from "./bank-token.vue?vue&type=template&id=766538be&scoped=true"
import script from "./bank-token.vue?vue&type=script&lang=js"
export * from "./bank-token.vue?vue&type=script&lang=js"
import style0 from "./bank-token.vue?vue&type=style&index=0&id=766538be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766538be",
  null
  
)

export default component.exports